export default __webpack_public_path__ + "static/media/ic_cart_unselected.e84cd537.svg";